
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 92.38 89.62"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"レイヤー 2"}},[_c('g',{attrs:{"data-name":"レイヤー 9"}},[_c('path',{attrs:{"fill":"#ddceb3","stroke":"#89620c","stroke-miterlimit":"10","stroke-width":"5.92","d":"M2.96 2.96h86.46v83.69H2.96z"}}),_c('path',{attrs:{"d":"M29.74 15.9v13H35v7.15h-5.26v21.32q2.79-.91 5.72-2.08l.19 7.21a122.75 122.75 0 01-19.43 6.7l-.78-7.67q3.18-.78 5.92-1.56V36.05h-5.59V28.9h5.59v-13zm46.87 3.58v6.76h-7.22V32h-7.8a75 75 0 0016.25 12.11l-2.6 7.48a94.54 94.54 0 01-8.77-6v2.54H43.26v-2.59a94.69 94.69 0 01-8.78 6l-2.6-7.48A75 75 0 0048.14 32h-7.8v-5.76h-7.28v-6.76h7.28v-5.27h8.45v5.27h12.15v-5.27h8.45v5.27zm-39.39 32.3h35.29v22h-8.45v-2.37H45.67v2.34h-8.45zm8.45 13.45h18.39v-7H45.67zm2.08-23.53H62a76.45 76.45 0 01-7.15-7.48 72.74 72.74 0 01-7.1 7.49zm1-10.4q1.17-1.3 1.82-2h8.45q1.3 1.3 1.88 2v-5.06H48.79z","fill":"#84183f"}})])])])
          )
        }
      }
    